import React from "react";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend,
  BarElement,
} from "chart.js";
import annotationPlugin from "chartjs-plugin-annotation";
import { Bar } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  annotationPlugin
);

export const StockRestockingGraph = ({ data }) => {
  // Helper function to calculate median

  if (data) {
    // Extract restocking data for calculations
    const restockingData = data?.map((scan) => scan.restockingSum);

    // Calculate the average and max
    const average =
      restockingData.reduce((a, b) => a + b, 0) / restockingData.length;
    const max = Math.max(...restockingData);

    // Calculate dynamic yAdjust to avoid label being cut off
    const percentFromTop = ((max - average) / max) * 100;
    const yAdjust = percentFromTop < 15 ? 10 : -15;

    return (
      <Bar
        options={{
          responsive: true,
          maintainAspectRatio: true,
          plugins: {
            legend: {
              display: false,
            },
            tooltip: {
              backgroundColor: "rgba(30, 41, 59, 0.95)",
              padding: 12,
              borderColor: "rgba(51, 65, 85, 1)",
              borderWidth: 1,
              titleColor: "#fff",
              bodyColor: "#fff",
              cornerRadius: 8,
            },
          },
          scales: {
            x: {
              grid: {
                display: false,
              },
              ticks: {
                color: "#6B7280",
                font: {
                  size: 11,
                },
              },
            },
            y: {
              type: "linear" as const,
              display: true,
              position: "left" as const,
              border: {
                display: false,
              },
              grid: {
                color: "rgba(0, 0, 0, 0.05)",
                drawTicks: false,
              },
              ticks: {
                color: "#6B7280",
                font: {
                  size: 11,
                },
                padding: 8,
                callback: function (value) {
                  return Number.isInteger(value) ? value + " pcs" : null;
                },
              },
            },
          },
        }}
        data={{
          labels: data?.map((scan) => {
            let date = new Date(scan.createdAt);

            const joursSemaine = [
              "dim",
              "lun",
              "mar",
              "mer",
              "jeu",
              "ven",
              "sam",
            ];

            let jourSemaine = joursSemaine[date.getDay()];
            let jour = date.getDate().toString().padStart(2, "0");
            let mois = (date.getMonth() + 1).toString().padStart(2, "0");

            return `${jourSemaine} ${jour}/${mois}`;
          }),
          datasets: [
            {
              label: "Réassort",
              data: restockingData,
              backgroundColor: data?.map((scan) =>
                scan.restockingSum > 0
                  ? "rgba(59, 130, 246, 0.65)"
                  : "rgba(156, 163, 175, 0.65)"
              ),
              borderColor: data?.map((scan) =>
                scan.restockingSum > 0
                  ? "rgba(59, 130, 246, 1)"
                  : "rgba(156, 163, 175, 1)"
              ),
              borderWidth: 0,
              borderRadius: 6,
              hoverBackgroundColor: data?.map((scan) =>
                scan.restockingSum > 0
                  ? "rgba(59, 130, 246, 0.8)"
                  : "rgba(156, 163, 175, 0.8)"
              ),
            },
          ],
        }}
      />
    );
  }

  return null;
};
